module.exports = __webpack_public_path__ + "img/btn_img_red_dummy.84b69fa4.png";